function Copyright() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="Copyright">
      AgriSwap &copy; {currentYear} <br/>Todos os direitos reservados
    </div>
  );
}

export default Copyright;